export enum Timeout {
  XXS = 100,
  XS = 500,
  S = 1000,
  M = 1500,
  L = 2000,
  XL = 4000,
  XXL = 8000,
}
